
import CryptoJS from "crypto-js";
import Config from "../config";
// import canonicalize, { stringify, stringifyCopy } from "canonical-json";

export const stableStringify = (value: any): string => {
  if (value === null || typeof value !== "object") {
    if (value instanceof Date) return JSON.stringify(value.toISOString());
    if (value === undefined) return "null";
    return JSON.stringify(value);
  }

  if (Array.isArray(value)) {
    return "[" + value.map(stableStringify).join(",") + "]";
  }

  const keys = Object.keys(value).sort();
  const keyValuePairs = keys.map(
    (key) => JSON.stringify(key) + ":" + stableStringify(value[key])
  );
  return "{" + keyValuePairs.join(",") + "}";
};

const signData = (data): string => {

  const HMAC_KEY = Config.SECURE_HMAC_SECRET_KEY;

  const normalized = stableStringify(data);
  const hash = CryptoJS.HmacSHA256(normalized, HMAC_KEY);
  const signature = CryptoJS.enc.Base64.stringify(hash);

  return signature;
}


const verifySignature = (data: any, providedSignature: string): boolean => {
  const HMAC_KEY = Config.SECURE_HMAC_SECRET_KEY;
 
  // 1. Canonical JSON (string)
  const canonicalJSON = stableStringify(data);
 
  if (!canonicalJSON) return false;
 
  // 2. FORCE UTF-8 encoding (THIS IS THE FIX)
  const message = CryptoJS.enc.Utf8.parse(canonicalJSON);
 
  // 3. HMAC SHA256
  const hash = CryptoJS.HmacSHA256(message, HMAC_KEY);
 
  // 4. Base64 encode
  const expectedSign = CryptoJS.enc.Base64.stringify(hash);
 
  return expectedSign === providedSignature;
};

function base64ToBytes(base64) {
  const binary = atob(base64);
  return Uint8Array.from(binary, c => c.charCodeAt(0));
}

async function importKey(secretKey) {
  return await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(secretKey),
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );
}


export async function decryptFirstName(secretKey, encryptedBase64) {
  const encryptedBytes = base64ToBytes(encryptedBase64);

  // AES-GCM nonce size = 12 bytes
  const nonce = encryptedBytes.slice(0, 12);
  const ciphertext = encryptedBytes.slice(12);

  const key = await importKey(secretKey);

  const decrypted = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: nonce,
    },
    key,
    ciphertext
  );

  return new TextDecoder().decode(decrypted);
}

export const HmacSignatureUtilities = {
  signData,
  verifySignature
}
